import styled from 'styled-components'

export const StyledAuctionSection = styled.div`
  margin-bottom: 15px;
`
